import { FaxStatusOption } from 'src/app/pages/fax-register/models/fax-status-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const faxStatusOptionActions = createEagerSelectActions<FaxStatusOption>('[Fax Type Options]');
